import { Checkout } from '@df/checkout/checkout.interfaces';

export namespace NBasketDeliveryMethods {
    export const ENDPOINTS = {
        loadRate: 'delivery/basket'
    };

    export const COLLECTION_CODES = ['storepickup_storepickup'];

    export const EXPERIMENT_CODE = 'basketDeliveryMethods';

    // export const STORAGE_KEY = 'basketDeliveryMethodSelectedCode';

    export interface IResponse {
        rates: Checkout.IShippingMethod[];
    }

    export enum EType {
        DELIVERY = 'delivery',
        COLLECTION = 'click_and_collect'
    }
}
